import { useSelector } from 'react-redux'

/** The company the app is currently scoped to, known from the request before its details land. */
export function useActiveCompany(): CompaniesItem | undefined {
  const companies = useSelector((state: Store) => state.auth.companies)
  const requestedCompanyId = useSelector((state: Store) => state.auth.company.lastRequestedCompanyId)
  const loadedCompanyId = useSelector((state: Store) => state.auth.company.data?.id)

  const activeCompanyId = requestedCompanyId ?? loadedCompanyId

  return activeCompanyId != null ? companies.find(company => company.id === activeCompanyId) : undefined
}
